import { render } from "./raceDivideManager.vue?vue&type=template&id=1a6c0478&scoped=true"
import script from "./raceDivideManager.vue?vue&type=script&lang=js"
export * from "./raceDivideManager.vue?vue&type=script&lang=js"

import "./raceDivideManager.vue?vue&type=style&index=0&id=1a6c0478&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6c0478"]])

export default __exports__